import axios from "axios";
import keycloak from 'Keycloak.js';
//todo configure baseUrl
//const baseUrl = window.location.origin+'/flowable-ui/app';
//const baseUrl = 'http://localhost:8080/flowable-ui/app';
//const baseUrl = window.location.protocol + '//' + window.location.hostname + ':3000/flowable-ui';
import { saveAs } from 'file-saver';
const baseUrl = `${window.location.origin}/${process.env.REACT_APP_BACKEND_FLOWABLE_CONTEXT_PATH}`;
const instance = axios.create({
  //  baseUrl: window.location.protocol + '//' + window.location.hostname + ':3000/flowable-ui/aaa',
  baseURL: `${window.location.origin}/${process.env.REACT_APP_FLOWABLE_CONTEXT_PATH}`,
  withCredentials: true
});


class AppTrackService {
  config = {
    headers: {
      /*'Cookie': 'FLOWABLE_REMEMBER_ME=SW1wR0ZvY201dHReYZExPYWFPSHV0QSUzRCUzRDpIYjJXeEZBT0ppNGRzVnJFWTZhJTJCQ0ElM0QlM0Q',*/
      //Cookie: 'FLOWABLE_REMEMBER_ME=alRnZ05teURJM0hHQ0E1WWl4Q3cyZyUzRCUzRDptTkdxdVRhQ2FEYzByY3hYVUJ0dExBJTNEJTNE'
    }
  };

    commentBody(msg){
        return {
        "message":msg
        }
    }

  async fetchProcInstancesDetailed(data) {
    return await instance.post(`/app/rest/query/process-instances-apptrack`, data).then(response => {
      console.log('Inside async fetchProcInstancesDetailed function: ', response.data.data)
      return response.data.data;
    });
  }


  async fetchProcInstanceById(id) {
    return await instance.get(keycloak.adjustEndpoint(`/app/rest/process-instances/${id}/apptrack`), this.config).then(response => {
      //console.log(response)
      return response.data;
    });
  }

  async fetchMktCommentsProcInstanceById(id) {
    return await instance.get(`/app/rest/process-instances/${id}/marketing-comments`, this.config).then(response => {
      //console.log(response)
      return response.data;
    });
  }

  fetchProcessInvestors() {
    return instance.get(`/app/rest/query/process-investors`, this.config).then(response => {
      console.log(response.data);
      return response.data;
    });
  }

  async fetchProcessLocations() {
    return await instance
      .get(`/app/rest/query/process-locations?appDefinitionKey=gobeyond`, this.config)
      .then(response => {
        //console.log(response.data)
        return response.data;
      });
  }

  async fetchProcessUsers() {
    return await instance.get(`/app/rest/query/process-users`, this.config).then(response => {
      console.log(response.data);
      return response.data;
    });
  }

  async fetchProcessAllEditors() {
    return await instance.get(`/app/rest/query/process-alleditors`, this.config).then(response => {
      console.log(response.data);
      return response.data;
    });
  }

  async fetchProcessAdvisors() {
    return await instance.get(`/app/rest/query/process-auditors`, this.config).then(response => {
      console.log(response.data);
      return response.data;
    });
  }

  fetchProcessSAYT(searchKey) {
    return instance
      .get(`/app/rest/query/process-sayt?appDefinitionKey=gobeyond_obs&searchKey=` + searchKey, this.config)
      .then(response => {
        console.log('Inside fetchProcessSAYT : ', response.data);
        return response.data;
      });
  }

  async fetchProcessStatuses() {
    return await instance.get(`/app/rest/query/process-statuses`, this.config).then(response => {
      console.log(response.data);
      return response.data;
    });
  }


  async fetchProcInstanceStatusById(id) {
    return await instance.get(`/app/rest/process-instances/${id}/status/`, this.config).then(response => {
      //console.log(response)
      return response.data;
    });
  }

  async fetchProcInstanceActivityCodeById(id) {
    return await instance.get(`/app/rest/process-instances/${id}/activitycode`, this.config).then(response => {
      //console.log(response)
      return response.data;
    });
  }

  async editActiveProcessInstance(id, targetTab) {
    return await instance.get(`/app/rest/tasks/${id}/action/edit-active`, this.config).then(response => {
      //console.log(response)
      return response.data;
    });
  }

  async startPaymentRequest(id) {
    return await instance.get(`/app/rest/tasks/${id}/action/payment-request`, this.config).then(response => {
      //console.log(response)
      return response.data;
    });
  }

  async claimActiveProcessInstance(id) {
    return await instance.get(`/app/rest/tasks/${id}/action/claim-active`, this.config).then(response => {
      //console.log(response)
      return response.data;
    });
  }

  async assignActive(id, userId) {
    return await instance
      .get(`/app/rest/tasks/${id}/action/assign-active?userId=${userId}`, this.config)
      .then(response => {
        //console.log(response)
        return response.data;
      });
  }

  async addComment(id, data) {
    return await instance.post((`/app/rest/process-instances/${id}/comments`), this.commentBody(data)).then(response => {
      //console.log(response.data)
      return response.data;
    });
  }

  async addMktComment(id, data) {
    return await instance.post(`/app/rest/process-instances/${id}/comments`, this.commentBody(data)).then(response => {
      //console.log(response.data)
      return response.data;
    });
  }
  
  async getComments(id) {
    return await instance.get(keycloak.adjustEndpoint(`/app/rest/process-instances/${id}/dailycomments`), this.config).then(response => {
      console.log("list data is ",response)
      return response.data;
    });
  }

  async getUserPriviledges() {
    return await instance.get(`/app/rest/account-extended`, this.config).then(response => {
      console.log(response.data);
      return response.data;
    });
  }

  async getUserPriviledgesWithDeadline(id) {
    return await instance.get(`/app/rest/account-extended-with-deadline?processInstanceId=${id}`, this.config).then(response => {
      console.log(response.data);
      return response.data;
    });
  }

  async fetchJvBanks() {
    return await instance.get(`/app/rest/query/process-jv-banks`, this.config).then(response => {
      console.log(response.data);
      return response.data;
    });
  }
  
  async fetchBanks() {
    return await instance.get(`/app/rest/query/process-banks`, this.config).then(response => {
      console.log(response.data);
      return response.data;
    });
  }

  openFileUrl(contentId) {
    return `${baseUrl}/app/rest/content/${contentId}/open`;
  }

  downloadUrl(contentId) {
    return `${baseUrl}/app/rest/content/${contentId}/download`;
  }

  async canChangeAuditor(id){
    return await instance.get(`/app/rest/process-instances/${id}/can-change-auditor`,
        this.config
    ).then(response=>{
        //console.log(response)
        return response.data;
    })
}

async changeAuditor(id){
    return await instance.get(`/app/rest/process-instances/${id}/change-auditor`,
        this.config
    ).then(response=>{
        //console.log(response)
        return response.data;
    })
}

async cancelProcess(p_id){
  return await instance.get(`/app/rest/process-instances/${p_id}/cancel`,
      this.config
  ).then(response=>{
      return response.data;
  })
}

startNew(){
  return `${baseUrl}` + `/app/rest/startnew?appDefinitionKey=`+process.env.REACT_APP_PROCESS_APP
}

exit(){
  return `${baseUrl}/exit`
}

// manualDownload = (userManual) => { 
//   if(userManual == 'Investor'){
//     saveAs(investorManual,('userManual_'+userManual));
//   }
// };

downloadUserManual(userManual) {
  return `${baseUrl}/staticTemplates/${userManual}`;
}

downloadZipPaymentRequestFiles(processId,instructionId) {
  return `${baseUrl}/app/rest/process-instances/${processId}/paymentRequest-documents/${instructionId}`;
}

async approvePaymentRequest(procId,instructionId,data){
  return await instance.post(`/app/rest/process-instances/${procId}/approve-paymentRequest/${instructionId}`,
      data
  ).then(response=>{
      //console.log(response)
      return response.data;
  })
}

async rejectPaymentRequest(procId,instructionId,data){
  return await instance.post(`/app/rest/process-instances/${procId}/reject-paymentRequest/${instructionId}`,
      data
  ).then(response=>{
      //console.log(response)
      return response.data;
  })
}

async checkEscrowStatus(p_id){
  return await instance.get(`/app/rest/process-instances/${p_id}/check-escrow-status`,
      this.config
  ).then(response=>{
      return response.data;
  })
}

async createEscrowAccount(p_id){
  return await instance.post(`/app/rest/process-instances/${p_id}/create-escrow-account`,
      this.config
  ).then(response=>{
      //console.log(response)
      return response.data;
  })
}

}



export default new AppTrackService();
